export type Callback = (...args: unknown[]) => void;

export interface Events {
    [event: string]: Callback[];
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function createEventEmitter() {
    const events: Events = {};

    const addEventListener = (event: string, callback: Callback) => {
        events[event] = events[event] || [];
        events[event]?.push(callback);
    };

    const emit = (event: string, ...args: unknown[]) => {
        (events[event] || []).forEach((callback) => {
            callback(...args);
        });
    };

    const removeEventListener = (event: string, callback: Callback) => {
        events[event] = (events[event] || []).filter((cb) => cb !== callback);
    };

    return {
        on: addEventListener,
        off: removeEventListener,
        removeEventListener,
        addEventListener,
        emit,
    };
}
